<script>
import * as m from '@app/paraglide/messages.js';
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import PositionControls from "./PositionControls.svelte";

/** @type {{event: {eventIndex: any, xPos?: string, yPos?: string, writingMode?: string}}} */
let { event } = $props();

let currentEventGroup = $derived(eventGroupState[projectState.selected]);
let displayWidth = $derived(currentEventGroup?.displayWidth || 32);
let displayHeight = $derived(currentEventGroup?.displayHeight || 15);

function recordHistory(name) {
    insertHistoryAction({
        name,
        eventGroup: projectState.selected,
        snapshots: [
            {
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            },
        ],
    });
}
</script>

<div class="position-controls-container">
    <PositionControls
        bind:xPos={event.xPos}
        bind:yPos={event.yPos}
        {displayWidth}
        {displayHeight}
        radioGroupName="position-{event?.eventIndex}"
        eventForResolve={event}
        onchange={recordHistory} />
    {#if event?.writingMode === "tbrl"}
        <button
            onclick={() => {
                event.writingMode = "default";
                recordHistory("reset writing mode");
            }}
            type="button"
            class="btn btn-sm btn-warning mt-2"
            title={m.input_position_vertical_text_title()}
            aria-label={m.input_position_vertical_text_aria_label()}>
            <i class="bi bi-sort-alpha-down"></i>
        </button>
    {/if}
</div>
